const paginationMixin = {
    data() {
        return {
            originalData: [],
            viewData: [],
            currentPage: 0,
            totalPage: 0,
            offset: 0,
        }
    },
    methods: {
        initPagination(data, offset, page){
            this.originalData = data;
            this.offset = offset;
            this.currentPage = page;
            this.totalPage = this.getTotalPage();
            
            this.viewData = this.getDataOfCurrentPage();
        },

        onPageChange: function (page) {
            this.currentPage = page;
            this.viewData = this.getDataOfCurrentPage();
        },

        onPageJump: function (page, previous, next, maxVisibleButtons) {
            this.currentPage = this.ServiceUtils.getCurrentPageOnPageJump(page, previous, next, maxVisibleButtons);
            this.viewData = this.getDataOfCurrentPage();
        },

        getDataOfCurrentPage() {
            return this.originalData.slice((this.currentPage - 1) * this.offset, this.currentPage * this.offset);
        },
        
        getTotalPage() {
            if (this.originalData.length === 0) {
                return 1;
            } else {
                return this.originalData.length % this.offset === 0 ? this.originalData.length / this.offset : parseInt(this.originalData.length / this.offset) + 1;
            }
        },
    }
};
export default paginationMixin;
